import { render, staticRenderFns } from "./orders-special-filter.vue?vue&type=template&id=0f50da08&scoped=true"
import script from "./orders-special-filter.vue?vue&type=script&lang=js"
export * from "./orders-special-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50da08",
  null
  
)

export default component.exports